import React, { Fragment, useState } from 'react';
import { Accordion, Card, Button, ListGroup, Tab, Row, Col, Nav } from 'react-bootstrap';
import RegistrationModal from './registration';
import { db } from '../services/firebase';
import firebase, { firestore } from 'firebase';
import { PDFDownloadLink } from "@react-pdf/renderer";
import PdfDocument from '../components/pdf';

function timeConverter(UNIX_timestamp){
    var a = new Date(UNIX_timestamp * 1000);
    var months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var hour = a.getHours();
    var min = a.getMinutes() === 0 ? "00" : a.getMinutes;
    var time = "le vendredi " + date + ' ' + month + ' ' + year + ' à ' + hour + ':' + min ;
    return time;
}

const PrayerItem = ({ id, data, admin, confirmationCallback }) => {
    const [showModal, setShowModal] = useState(false);
    const [sex, setSex] = useState("");

    const toggleModal = (sex) => {
        setShowModal(!showModal);
        setSex(sex);
    }

    const handleRegistration = (form) => {
        form.sexe = sex;
        return db.collection(data.code).doc(data.id).update({
            invites: firebase.firestore.FieldValue.arrayUnion(form)
        }).then(() => {
            confirmationCallback();
            setShowModal(false);
        });
    }

    return(
        <Fragment>
            <Card>
                <Accordion.Toggle as={Card.Header} variant="link" eventKey={id} className="prayerItem">
                    <strong>Réserver ma place </strong>{"pour " + timeConverter(data.date.seconds)} ({data.title})
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={id}>
                    <Card.Body>
                        <div className="d-flex justify-content-between flex-sm-row flex-column">
                            <div className="d-flex flex-column mb-2 mb-sm-0">
                                <span>Taux de remplissage hommes ({Math.min(100, data.invites.filter((invite) => invite.sexe === "homme").length*100/data.max_hommes)}%)</span>
                                <span>Taux de remplissage femmes ({Math.min(100, data.invites.filter((invite) => invite.sexe === "femme").length*100/data.max_femmes)}%)</span>
                                <span>{data.max_hommes} hommes maximum</span>
                                <span>{data.max_femmes} femmes maximum</span>
                            </div>
                            {admin ?
                                <div className="d-flex flex-sm-column flex-row">
                                    <Button variant="success" className="mb-sm-2 mr-2 mr-sm-0" disabled={true} onClick={() => {}}>
                                        {data.invites.filter((invite) => invite.sexe === "homme").length >= data.max_hommes ? "Complet hommes" : "Places hommes disponibles"}
                                    </Button>
                                    <Button variant="info" disabled={true} onClick={() => {}}>
                                        {data.invites.filter((invite) => invite.sexe === "femme").length >= data.max_femmes ? "Complet femmes" : "Places femmes disponibles"}
                                    </Button>
                                </div>
                                :
                                <div className="d-flex flex-sm-column flex-row">
                                    <Button variant="success" className="mb-sm-2 mr-2 mr-sm-0" disabled={data.invites.filter((invite) => invite.sexe === "homme").length >= data.max_hommes} onClick={() => toggleModal("homme")}>
                                        {data.invites.filter((invite) => invite.sexe === "homme").length >= data.max_hommes ? "Complet hommes" : "Réserver une place homme"}
                                    </Button>
                                    <Button variant="info" disabled={data.invites.filter((invite) => invite.sexe === "femme").length >= data.max_femmes} onClick={() => toggleModal("femme")}>
                                        {data.invites.filter((invite) => invite.sexe === "femme").length >= data.max_femmes ? "Complet femmes" : "Réserver une place femme"}
                                    </Button>
                                </div>
                            }
                        </div>
                        {admin ?
                            <Card className="mt-3">
                                <Card.Header className="d-flex justify-content-between align-items-center">
                                    <span>Liste des invités</span>
                                    <PDFDownloadLink
                                        document={<PdfDocument data={data} date={timeConverter(data.date.seconds)} />}
                                        fileName={data.date.seconds + ".pdf"}
                                    >
                                        {({ blob, url, loading, error }) =>
                                            loading ? 
                                            <Button>Téléchargement...</Button>
                                            : 
                                            <Button>Imprimer</Button>
                                        }
                                    </PDFDownloadLink>
                                </Card.Header>
                                <Card.Body>
                                    <Tab.Container id="left-tabs-example" defaultActiveKey="hommes">
                                        <Row>
                                            <Col sm={3}>
                                            <Nav variant="pills" className="flex-column">
                                                <Nav.Item>
                                                <Nav.Link eventKey="hommes">Hommes</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                <Nav.Link eventKey="femmes">Femmes</Nav.Link>
                                                </Nav.Item>
                                            </Nav>
                                            </Col>
                                            <Col sm={9}>
                                            <Tab.Content>
                                                <Tab.Pane eventKey="hommes">
                                                    <ListGroup variant="flush">
                                                        {data.invites.filter((invite) => invite.sexe === "homme").map((invite, idx) => (
                                                            <ListGroup.Item key={idx}>{invite.prenom + " " + invite.nom + " (" + invite.email + ", " + invite.telephone + ")"}</ListGroup.Item>
                                                        ))}
                                                    </ListGroup>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="femmes">
                                                    <ListGroup variant="flush">
                                                        {data.invites.filter((invite) => invite.sexe === "femme").map((invite, idx) => (
                                                            <ListGroup.Item key={idx}>{invite.prenom + " " + invite.nom + " (" + invite.email + ", " + invite.telephone + ")"}</ListGroup.Item>
                                                        ))}
                                                    </ListGroup>
                                                </Tab.Pane>
                                            </Tab.Content>
                                            </Col>
                                        </Row>
                                    </Tab.Container>
                                </Card.Body>
                            </Card>
                            : null
                        }
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
            <RegistrationModal date={timeConverter(data.date.seconds) + " (" + data.title + ")"} show={showModal} closeHandler={toggleModal} registerCallback={handleRegistration} />
        </Fragment>
    );
}

export default PrayerItem;